import { Currency, supportedTokens } from '@/constants';

const envValue = ((import.meta.env['VITE_UNSUPPORTED_DIRECTIONS'] ?? '') as string).trim();

const parsedEntries = envValue
  ? envValue.split(',').map((pair) => {
      const trimmed = pair.trim();
      const isExplicitlyAllowed = trimmed.startsWith('!');
      const pairStr = isExplicitlyAllowed ? trimmed.slice(1).trim() : trimmed;
      const [tokenFrom, tokenTo] = pairStr.split('>').map((token) => token.trim());
      return { isExplicitlyAllowed, tokens: [tokenFrom, tokenTo] as [string, string] };
    })
  : [];

const unsupportedDirections = new Set<string>(
  parsedEntries
    .filter(({ isExplicitlyAllowed }) => !isExplicitlyAllowed)
    .filter((entry): entry is { isExplicitlyAllowed: false; tokens: [Currency | '*', Currency | '*'] } => {
      const [t0, t1] = entry.tokens;
      return (
        ((supportedTokens as string[]).includes(t0) && (supportedTokens as string[]).includes(t1)) ||
        (t0 === '*' && (supportedTokens as string[]).includes(t1)) ||
        (t1 === '*' && (supportedTokens as string[]).includes(t0))
      );
    })
    .map(({ tokens: [tokenFrom, tokenTo] }) => `${tokenFrom}>${tokenTo}`)
);

const explicitlyAllowedDirections = new Set<string>(
  parsedEntries
    .filter(({ isExplicitlyAllowed }) => isExplicitlyAllowed)
    .filter((entry): entry is { isExplicitlyAllowed: true; tokens: [Currency, Currency] } => {
      const [t0, t1] = entry.tokens;
      return (supportedTokens as string[]).includes(t0) && (supportedTokens as string[]).includes(t1);
    })
    .map(({ tokens: [tokenFrom, tokenTo] }) => `${tokenFrom}>${tokenTo}`)
);

export const checkSupportedPair = (from: Currency, to: Currency) => {
  const pair = `${from}>${to}`;
  if (explicitlyAllowedDirections.has(pair)) return true;

  const isDirectionUnsupported = unsupportedDirections.has(pair);
  const isWildcardFromDirectionUnsupported = unsupportedDirections.has(`${from}>*`);
  const isWildcardToDirectionUnsupported = unsupportedDirections.has(`*>${to}`);

  return !isDirectionUnsupported && !isWildcardFromDirectionUnsupported && !isWildcardToDirectionUnsupported;
};
